import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

/**
 * Status is rendered as a small tinted pill, never as coloured text.
 *
 * Every tinted variant pairs a tint background with its `on-tint` foreground —
 * the darkened text colour that reaches 4.5:1 against that tint. Do not swap in
 * the solid `success` / `destructive` hues here; they fail AA on their own tint.
 */
const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-md border-hairline px-2 py-0.5 text-label font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        accent: 'border-transparent bg-primary-tint text-primary-on-tint',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        success: 'border-transparent bg-success-tint text-success-on-tint',
        warning: 'border-transparent bg-warning-tint text-warning-on-tint',
        destructive: 'border-transparent bg-destructive-tint text-destructive-on-tint',
        outline: 'border-border-strong bg-card text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
